import { render, staticRenderFns } from "./RevisionCardList.vue?vue&type=template&id=7e7a61f0&scoped=true&"
import script from "./RevisionCardList.vue?vue&type=script&lang=js&"
export * from "./RevisionCardList.vue?vue&type=script&lang=js&"
import style0 from "./RevisionCardList.vue?vue&type=style&index=0&id=7e7a61f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7a61f0",
  null
  
)

export default component.exports